<template>
  <v-row
    no-gutters
    justify="center"
  >
    <v-col
      cols="12"
      class="pa-3"
    >
      <v-img
        style="margin: 0"
        :src="`https://api.yundangdang.cn/base/scene/wxcode/platform/auth/get?device_id=${deviceId}&user_id=${userId}&random=${random}&platform=platform`"
      >
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
          >
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-col>
    <v-col cols="12">
      <v-footer
        absolute
        color="transparent"
        class="pa-5 justify-center"
      >
        <v-row no-gutters>
          <v-col
            v-if="scanned"
            cols="12"
            class="d-flex align-center justify-center headline success--text pb-3"
          >
            <v-icon class="mr-2 success--text">mdi-check-circle</v-icon>
            <span>扫描成功</span>
          </v-col>
          <v-col
            cols="12"
            class="text-center subtitle"
          >
            请使用微信扫描二维码
          </v-col>
        </v-row>
      </v-footer>
    </v-col>
  </v-row>
</template>

<script>
  import auth from '../../../mixins/auth'
  import { mapState } from 'vuex'

  export default {
    name: 'auth',
    mixins: [auth],
    data: () => ({
      loading: false,
      scanned: false,

      random: Math.random()
    }),
    computed: {
      ...mapState({
        deviceId: state => state.deviceId
      }),
      userId() {
        return _.get(this.$route, 'query.user_id') || ''
      }
    },
    methods: {
      onScanned() {
        this.scanned = true
      },
      onConfirmed(message) {
        this.loading = true
        this.$http
          .post('/base/auth/wxcode', {
            login_id: _.get(message, 'login_id')
          })
          .then(() => {
            this.activate()
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false
          })
      }
    },
    mounted() {
      this.$bus.$on('user.scanned', this.onScanned)
      this.$bus.$on('user.confirmed', this.onConfirmed)
    },
    beforeDestroy() {
      this.$bus.$off('user.scanned')
      this.$bus.$off('user.confirmed')
    }
  }
</script>
